"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
	// If the importer is in node compatibility mode or this is not an ESM
	// file that has been converted to a CommonJS file using a Babel-
	// compatible transform (i.e. "__esModule" has not been set), then set
	// "default" to the CommonJS "module.exports" for node compatibility.
	isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
		value: mod,
		enumerable: true
	}) : target,
	mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Try_exports = {};
__export(Try_exports, { Try: () => Try });
module.exports = __toCommonJS(Try_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
require("../skewProtection");
require("../utils/dynamicImport");
function _assert_this_initialized(self) {
	if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	return self;
}
function _call_super(_this, derived, args) {
	derived = _get_prototype_of(derived);
	return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
	if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}
function _create_class(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	return Constructor;
}
function _define_property(obj, key, value) {
	if (key in obj) Object.defineProperty(obj, key, {
		value,
		enumerable: true,
		configurable: true,
		writable: true
	});
	else obj[key] = value;
	return obj;
}
function _get_prototype_of(o) {
	_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o2) {
		return o2.__proto__ || Object.getPrototypeOf(o2);
	};
	return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
	subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: {
		value: subClass,
		writable: true,
		configurable: true
	} });
	if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_reflect_construct() {
	try {
		var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch (_) {}
	return (_is_native_reflect_construct = function() {
		return !!result;
	})();
}
function _possible_constructor_return(self, call) {
	if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
	return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
	_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o2, p2) {
		o2.__proto__ = p2;
		return o2;
	};
	return _set_prototype_of(o, p);
}
function _type_of(obj) {
	"@swc/helpers - typeof";
	return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var Try = /* @__PURE__ */ (function(_React_Component) {
	"use strict";
	_inherits(Try2, _React_Component);
	function Try2() {
		_class_call_check(this, Try2);
		var _this = _call_super(this, Try2, arguments);
		_define_property(_this, "state", {
			error: void 0,
			componentStack: void 0
		}), _define_property(_this, "retry", function() {
			return new Promise(function(resolve) {
				_this.setState({
					error: void 0,
					componentStack: void 0
				}, function() {
					resolve();
				});
			});
		});
		return _this;
	}
	_create_class(Try2, [{
		key: "componentDidCatch",
		value: function componentDidCatch(error, errorInfo) {
			this.setState({ componentStack: errorInfo.componentStack || void 0 });
			if (process.env.NODE_ENV === "development") {
				var routeInfo = this.props.routeInfo;
				console.error(`[One] Error in route${(routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.routeName) ? ` "${routeInfo.routeName}"` : ""}:`, error, "\nComponent Stack:", errorInfo.componentStack);
			}
			if (typeof window !== "undefined" && typeof CustomEvent !== "undefined") window.dispatchEvent(new CustomEvent("one-error", { detail: {
				error: {
					message: error.message,
					stack: error.stack,
					name: error.name
				},
				route: this.props.routeInfo || {},
				componentStack: errorInfo.componentStack,
				timestamp: Date.now(),
				type: "render"
			} }));
		}
	}, {
		key: "render",
		value: function render() {
			var { error, componentStack } = this.state;
			var { catch: ErrorBoundary, children, routeInfo } = this.props;
			if (!error) return children;
			var enhancedRouteInfo = {
				...routeInfo,
				errorType: "render",
				componentStack
			};
			return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ErrorBoundary, {
				error,
				retry: this.retry,
				route: enhancedRouteInfo
			});
		}
	}], [{
		key: "getDerivedStateFromError",
		value: function getDerivedStateFromError(error) {
			return { error };
		}
	}]);
	return Try2;
})(import_react.default.Component);
//# sourceMappingURL=Try.js.map
